var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.got_feature('feature_can_use_payable_or_receivable_effects'))?_c('v-container',{staticClass:"container-full-bg-gray",attrs:{"fluid":""}},[(_vm.currentCompany)?_c('bank-effects-table',{ref:"effectsTable"}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }